module.exports = __webpack_public_path__ + "media/images/emblems/Guttannen-coat_of_arms-386f5664255a15b5299a9d6c6ecb14ec.svg";